import DriveAssetType from '../constants/DriveAssetType';

export type DriveAssetId = number;

export default class DriveAsset {
  id: DriveAssetId | null = null;
  externalClassReference = '';
  description = '';
  identifier = '';
  registrationNumber = '';
  assetId: number | null = null;
  assetClassId: number | null = null;
  assetGroupId: number | null = null;
  requestedType: DriveAssetType | null = null;

  static create(
    id: DriveAssetId,
    externalClassReference: string,
    description: string,
    identifier: string,
    registrationNumber: string,
    type: DriveAssetType,
    assetClassId: number | null = null,
    assetGroupId: number | null = null,
    assetId: number | null = null,
  ): DriveAsset {
    const asset = new DriveAsset();
    asset.id = id;
    asset.externalClassReference = externalClassReference;
    asset.description = description;
    asset.identifier = identifier;
    asset.registrationNumber = registrationNumber;
    asset.requestedType = type;
    asset.assetClassId = assetClassId;
    asset.assetGroupId = assetGroupId;
    asset.assetId = assetId;
    return asset;
  }
}
